module.exports = __webpack_public_path__ + "img/news8-6.3ea69b54.png";